import React, { useEffect } from "react";
import { FaUsers, FaHandHoldingHeart, FaAward, FaBook, FaGlobe } from "react-icons/fa";
import CountUp from "react-countup";
import AOS from "aos";
import "aos/dist/aos.css";
import "./ImpactStats.css";

const stats = [
  { id: 1, title: "Communities Supported", value: 500, icon: <FaUsers />, delay: 100 },
  { id: 2, title: "Lives Impacted", value: 1000, icon: <FaHandHoldingHeart />, delay: 200 },
  { id: 3, title: "Years of Service", value: 5, icon: <FaAward />, delay: 300 },
  { id: 4, title: "Ongoing Programs", value: 2, icon: <FaBook />, delay: 400 },
  { id: 5, title: "Global Reach", value: 1, icon: <FaGlobe />, delay: 500 },
];

const ImpactStats = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true, easing: "ease-out-cubic" });
  }, []);

  return (
    <section className="impact-section-home" id="impact-section">
      <div className="impact-container-home">
        <h2 className="impact-title-home" data-aos="fade-up">
          Our <span>Impact</span>
        </h2>

        <div className="impact-grid-home">
          {stats.map((stat) => (
            <div
              className="impact-card-home"
              key={stat.id}
              data-aos="fade-up"
              data-aos-delay={stat.delay}
            >
              <div className="impact-icon-home">{stat.icon}</div>
              <h3 className="impact-value-home">
                <CountUp
                  start={0}
                  end={stat.value}
                  duration={2}
                  separator=","
                />
              </h3>
              <p className="impact-text-home">{stat.title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ImpactStats;
